<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <h3>Gerenciar as faturas e suas baixas</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field v-model="search" prepend-icon="mdi-feature-search-outline" label="Pesquisar" clearable></v-text-field>
          </v-col>
          <v-col>
            <v-autocomplete
                :items="tiposStatus"
                v-model="statusSelecionado"
                item-text="Status"
                item-value="idSituacao"
                label="Filtrar por situação"
                @change="getFaturamentos()"
                hide-details
                outlined
                dense
                clearable
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
                :items="unidadesList"
                v-model="unidadeSelecionada"
                item-text="Unidade"
                item-value="IdUnidade"
                label="Filtrar por unidade"
                @change="getFaturamentos()"
                hide-details
                outlined
                dense
                clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="2" v-if="statusSelecionado != null">
            <v-btn color="primary" width="100%" v-bind:id="'2.4'" @click="[gerarpdf()]"
                   dark>
              Gerar PDF
            </v-btn>
          </v-col>
          <v-col cols="2" v-if="statusSelecionado != null || unidadeSelecionada != null">
            <v-btn color="primary" width="100%" v-bind:id="'2.4'" @click="[limparFiltros()]"
                   dark>
              Limpar Filtros
            </v-btn>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col justify="center" align="center">
            <v-btn icon small dark color="primary" @click="Mes-- , getMes(), getFaturamentos()"><v-icon>mdi-chevron-left</v-icon></v-btn>
            <strong style="padding-left: 5%;padding-right: 5%">{{ monthNames[this.Mes].Status }}</strong>
            <v-btn icon small dark color="primary" @click="Mes++ , getMes(), getFaturamentos()"><v-icon>mdi-chevron-right</v-icon></v-btn>
          </v-col>
        </v-row> -->
        <v-data-table
            :items="faturamentos"
            :headers="headers"
            :search="search"
            :loading="loadFatura"
            >
          <template v-slot:[`item.IdStatus`]="{ item }">
            <v-chip
              v-if="item.IdStatus === 0"
              :class="chipPendente"
              rounded
              color="gray"
            >
              {{ getStatusLabel(item.IdStatus) }}
            </v-chip>
            <v-chip
              v-else-if="item.IdStatus === 1"
              :class="chipPagamento"
              rounded
              color="primary"
            >
              {{ getStatusLabel(item.IdStatus) }}
            </v-chip>
            <v-chip
              v-else-if="item.IdStatus === 2"
              :class="chipCancelado"
              rounded
              color="warning"
            >
              {{ getStatusLabel(item.IdStatus) }}
            </v-chip>
          </template>
          <template v-slot:[`item.FaturaNumero`]=" { item } ">
            {{item.FaturaNumero}}/{{item.FaturaAno}}
          </template>
          <template v-slot:[`item.DataEmissao`]=" { item } ">
            {{`${$moment(item.DataEmissao).format('L')}`}}
          </template>
          <template v-slot:[`item.Parcela`]=" { item } ">
            {{`${item.Parcela} / ${item.NumeroParcelas}`}}
          </template>
          <template v-slot:[`item.DataVencimento`]=" { item } ">
            {{`${$moment(item.DataVencimento).format('L')}`}}
          </template>
          <template v-slot:[`item.Valor`]=" { item } ">
            R$ {{formatPrice(item.Valor)}}
          </template>
          <template v-slot:[`item.actions`]=" { item } ">
            <v-btn v-if="item.IdStatus == 0" @click="[zerarCampos(),getFormasPagamento(), getParcela(item.IdFatura, item.Parcela), system.modalRegistrarBaixa = true]" icon>
              <v-icon title="Registrar baixa manual">mdi-check</v-icon>
            </v-btn>
          </template>
        </v-data-table>

      </v-card-text>
    </v-card>
    <v-dialog width="40%" v-model="system.modalRegistrarBaixa">
      <v-card>
        <v-card-title>Registrar baixa</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ }">
                  <v-autocomplete
                      :items="tiposPagamento"
                      v-model="faturaunica.IdFormaPagamento"
                      item-text="FormaPagamento"
                      item-value="IdFormaPagamento"
                      label="Forma de Pagamento*"
                      hide-details
                      outlined
                      dense
                  ></v-autocomplete>
                </template>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ }">
                  <v-select
                      :items="faturaunica.parcela"
                      v-model="faturaunica.parcela"
                      item-text="Parcela"
                      item-value="IdSequencial"
                      label="Parcelas da Fatura*"
                      hide-details
                      outlined
                      dense
                  ></v-select>
                </template>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                  v-model="anexoFormaPagamento"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ }">
                  <v-file-input
                      small-chips
                      show-size
                      label="Anexo*"
                      v-model="files"
                  ></v-file-input>
                </template>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                  v-model="MenuDataPagamento"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="dataPagamento"
                      label="Data Pagamento"
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      type="date"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dataPagamento"
                    @input="MenuDataPagamento"

                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-menu
                  v-model="Observacao"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ }">
                  <v-row>
                    <v-icon>mdi-text</v-icon>
                    <v-text-field
                        v-model="observacaoPagamento"
                        label="Adicionar observação (opcional)"
                    ></v-text-field>
                  </v-row>
                </template>
              </v-menu>
            </v-col>
            <v-row>
              <v-col cols="12">
                <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{ }">
                    {{faturaunica.parcela}}ª parcela da fatura. Valor: R$ {{faturaunica.valor}}.
                    Vencimento: {{new Date(faturaunica.vencimento).toLocaleDateString()}}
                  </template>
                </v-menu>
              </v-col>
            </v-row>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="
              [
                (system.modalRegistrarBaixa = !system.modalRegistrarBaixa),
                zerarCampos(),
              ]
            "
              large
              dark
          >
            Cancelar
          </v-btn>
          <v-btn
              :loading="myloadingvariable"
              @click="registrarbaixa('thumnail', $event.target.files)"
              color="primary"
              large
              dark
          >Registrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <AlertSystem :snackbar="system.snackbar"></AlertSystem>
  </v-container>
</template>

<script>
import AlertSystem from "../components/AlertSystem.vue";

// @ is an alias to /src
export default {
  name: 'Faturas',
  components: {
    AlertSystem,
  },
  data: () => ({
    headers: [
      {text: "CNPJ", value: "CNPJ", align: 'center'},
      {text: "Razão Social", value: "RazaoSocial", align: 'left'},
      {text: "Fatura", value: "FaturaNumero", align: 'center'},
      {text: "Forma de pagamento", value: "FormaPagamento", align: 'center'},
      {text: "Situação", value: "IdStatus", align: 'center'},
      // {text: "Emissão parcela", value: "DataEmissao", align: 'center'},
      {text: "Vencimento", value: "DataVencimento", align: 'center'},
      {text: "Nº parcela", value: "Parcela", align: 'center'},
      {text: "Valor", value: "Valor", align: 'right'},
      // {text: "Nota Fiscal", value: "NotaFiscalNumero", align: 'center'},
      {text: "Ações", value:"actions", align: 'center'}
    ],
    calendar:{
      type: 'month',
      typeOptions: [
        { text: 'Dia', value: 'day' },
        { text: '4 Dias', value: '4day' },
        { text: 'Semana', value: 'week' },
        { text: 'Mês', value: 'month' }
      ]
    },
    system:{
      snackbar: {},
      modalRegistrarBaixa: false,
    },
    faturamentos: [],
    tiposStatus:[
      {
        idSituacao: 0,
        Status: 'Faturas vencidas'
      },
      {
        idSituacao: 1,
        Status: 'Faturas pagas'
      },
      {
        idSituacao: 2,
        Status: 'Faturas canceladas'
      },
      {
        idSituacao: 3,
        Status: 'Faturas abertas',
      },
    ],
    MenuDataPagamento:false,
    tiposPagamento:[],
    tipoParcelamento: [],
    search: '',
    status: 1,
    loadFatura: false,
    dataPagamento:null,
    myloadingvariable: false,
    unidadesList: [],
    dataInicialFatura: '',
    dataFinalFatura: '',
    menuDataInicial: false,
    menuDataFinal: false,
    today: '2020-09-16',
    atualDay:'2020-09-16',
    statusSelecionado: null,
    FaturaDataVencimento: null,
    unidadeSelecionada:null,
    formadePagamento: null,
    tipoPagamentoSelecionado: null,
    anexoFormaPagamento:null,
    faturaunicageral:[],
    // Mes:null,
    monthNames:[
    {
      idMes: 0,
      Status: 'Janeiro'
    },
    {
      idMes: 1,
      Status: 'Fevereiro'
    },
    {
      idMes: 2,
      Status: 'Março'
    },
    {
      idMes: 3,
      Status: 'Abril',
    },
      {
        idMes: 4,
        Status: 'Maio',
      },
      {
        idMes: 5,
        Status: 'Junho',
      },
      {
        idMes: 6,
        Status: 'Julho',
      },
      {
        idMes: 7,
        Status: 'Agosto',
      },
      {
        idMes: 8,
        Status: 'Setembro',
      },
      {
        idMes: 9,
        Status: 'Outubro',
      },
      {
        idMes: 10,
        Status: 'Novembro',
      },
      {
        idMes: 11,
        Status: 'Dezembro',
      },
  ],
    faturaunica:{
      idFatura: null,
      idParcela: null,
      valor:null,
      parcela:null,
      vencimento:null,
      IdFormaPagamento:null,
    },
    observacaoPagamento:null,
    Observacao:null,
    parcelamentoSelecionado: null,
    files: null,
    snackbar: false,
    filelist: null
  }),
  methods: {
    getUnidades() {
      this.axios('unidades').then(res => {
        this.unidadesList = res.data
      })
    },
    getFaturamentos () {
      this.loadFatura = true
      this.axios.get('/faturamentos', {
        params:{
          IdSituacao: this.statusSelecionado,
          IdUnidade: this.unidadeSelecionada
          // Mounth: this.Mes + 1,
        }
      }).then( res => {
        this.faturamentos = res.data.filter(element => {
          element.RazaoSocial = this.prepareNameFilter(element.RazaoSocial)
          return element;
        })
      }).finally(() => {
        this.loadFatura = false;
      })
    },
    // getMes(){
    //   if(this.Mes > 11){
    //     this.Mes = 0
    //   }
    //   if(this.Mes < 0){
    //     this.Mes = 11
    //   }
    // },
    getStatusLabel(idStatus) {
      // Função para obter a etiqueta de status com base no valor de IdStatus
      switch (idStatus) {
        case 0:
          return 'Pendente';
        case 1:
          return 'Liquidado';
        case 2:
          return 'Cancelado';
        default:
          return '';
      }
    },
    getParcela(IdFatura, Parcela){
      this.axios.get(`/faturamentos/${IdFatura}/${Parcela}`)
          .then( res => {
            res.data.map((elem) => {
              this.faturaunicageral = res.data
              this.faturaunica.idFatura = elem.IdFatura
              this.faturaunica.idParcela = elem.IdSequencial
              this.faturaunica.valor = elem.Valor
              this.faturaunica.parcela = elem.Parcela
              this.faturaunica.vencimento = elem.DataVencimento
              this.faturaunica.IdFormaPagamento = elem.IdFormaPagamento
            });
          })

    },
    registrarbaixa( ){
      if (this.faturaunica.IdFormaPagamento == null || this.files.length == 0 || this.faturaunica.parcela == null || this.dataPagamento == null) {
        this.system.snackbar = {
          snackbar: true,
          text: "Preencha todos os campos obrigatorios",
          color: "red",
        };
      } else{
        let formData = new FormData();
        formData.append('files', this.files);
        this.axios.post(`/faturamentos/registrarBaixa`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "charset": "utf-8",
          },
          params: {
            FaturaId: this.faturaunica.idFatura,
            numeroParcela: this.faturaunica.parcela,
            TipoPagamento: this.faturaunica.IdFormaPagamento,
            Observacao: this.observacaoPagamento,
            DataPagamento: this.dataPagamento,
            Valor: this.faturaunica.valor,
          }
        }).then( res => {
          this.system.snackbar = {
            snackbar: true,
            text: res.data,
            color: "green",
          };
          this.system.modalRegistrarBaixa = !this.system.modalRegistrarBaixa
          this.getFaturamentos();
        }).catch(e => {
          this.system.snackbar = {
            snackbar: true,
            text: e.response.data,
            color: "red",
          };
        })
      }
    },

    limparFiltros(){
      this.statusSelecionado = null
      this.search = null
      this.unidadeSelecionada = null
      // this.Mes = this.$moment().format('M') - 1
      this.getFaturamentos();
    },

    zerarCampos(){
      this.files = [];
      this.faturaunica.IdFormaPagamento = null;
      this.observacaoPagamento = null;
      this.faturaunica.parcela = null;
      this.dataPagamento = null;
      this.faturaunica.valor = null;
    },

    getFormasPagamento(){
      this.axios.get('/faturamentos/formasPagamento')
        .then( res => {
          this.tiposPagamento = res.data.filter(element => {
            if(element.IdFormaPagamento != 1){
              return {
                IdFormaPagamento: element.IdFormaPagamento,
                FormaPagamento: element.FormaPagamento,
                BaixaManual: element.BaixaManual,
              }
            }
          })
        })
    },

    formatPrice(value) {
      return value.toFixed(2)
                  .replace('.', ',')
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    gerarpdf(){
      this.axios.get("/faturamentos/gerarpdf", {
      params: {
        IdSituacao: this.statusSelecionado,
        IdUnidade: this.unidadeSelecionada,
        CNPJ: this.search
      },
      responseType: 'arraybuffer'
    }).then((res) => {
        var blob = new Blob([res.data], {
          type: "application/pdf",
        });
        var url = window.URL.createObjectURL(blob);
        window.open(url);
        //this.loadFatura = false
        //this.modalRegistrarBaixa = false
      })
      .catch(error => {
          // clearInterval
        if (error.response.status == 400) {
          this.system.snackbar = {
            snackbar: true,
            text: 'Informe a unidade e as datas corretamente',
            color: "red",
          };
        }
      })
    }
  },
  mounted() {
    // this.Mes = this.$moment().format('M') - 1
    this.today = this.$moment().format('YYYY-MM-DD')
    this.atualDay = this.$moment().format('YYYY-MM-DD')
    // this.getMes()
    this.getFaturamentos()
    this.getUnidades()
  }
}
</script>
